// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ih62","col":"styles_col__1KA5W"};